import{d as e}from"./chunk-XWRW4TO4.js";import{b as r,c as o}from"./chunk-RULY5VOQ.js";import{m as s}from"./chunk-HBP5N4FR.js";s();var m=()=>{let t=e(r),n=e(o);return{isPending:t,errorMessage:n}};export{m as a};
//# sourceMappingURL=chunk-DXWP7WID.js.map
